import React, { useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";

// Import modal
import HomeworkDetailModal from "../modals/HomeworkDetailModal";

const HomeworkList = () => {
  const routes = all_routes;
  const [filterStatus, setFilterStatus] = useState("all");
  const [selectedHomework, setSelectedHomework] = useState<any>(null);

  // Mock data
  const mockHomework = [
    {
      id: 1,
      title: "Algebra Practice Problems",
      subject: "Mathematics",
      teacher: "Ms. Johnson",
      assignedDate: "2024-07-15",
      dueDate: "2024-07-22",
      status: "Pending",
      description: "Complete exercises 1-20 from Chapter 5",
      maxPoints: 100,
      format: "PDF, DOC, DOCX",
      estimatedTime: "2 hours",
      allowLate: true,
      attachments: [
        { name: "Chapter5_Exercises.pdf", url: "#", size: "2.3 MB" },
      ],
    },
    {
      id: 2,
      title: "Physics Lab Report",
      subject: "Physics",
      teacher: "Dr. Smith",
      assignedDate: "2024-07-10",
      dueDate: "2024-07-20",
      status: "Submitted",
      description: "Submit lab report on pendulum experiment",
      maxPoints: 50,
      submittedDate: "2024-07-19",
      grade: 45,
      feedback:
        "Excellent work! Your analysis was thorough and well-documented.",
    },
    {
      id: 3,
      title: "Essay on Climate Change",
      subject: "English",
      teacher: "Mr. Davis",
      assignedDate: "2024-07-08",
      dueDate: "2024-07-18",
      status: "Overdue",
      description: "Write 500-word essay on climate change impacts",
      maxPoints: 100,
      format: "DOC, DOCX",
      estimatedTime: "3 hours",
    },
  ];

  const filteredHomework = mockHomework.filter(
    (hw) => filterStatus === "all" || hw.status === filterStatus
  );

  const getStatusColor = (status: string) => {
    switch (status) {
      case "Submitted":
        return "badge-soft-success";
      case "Pending":
        return "badge-soft-warning";
      case "Overdue":
        return "badge-soft-danger";
      default:
        return "badge-soft-secondary";
    }
  };

  const handleViewHomework = (homework: any) => {
    setSelectedHomework(homework);
  };

  const stats = {
    total: mockHomework.length,
    pending: mockHomework.filter((h) => h.status === "Pending").length,
    submitted: mockHomework.filter((h) => h.status === "Submitted").length,
    overdue: mockHomework.filter((h) => h.status === "Overdue").length,
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={routes.studentDashboard}>Student Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">My Homework</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Stats */}
          <div className="row">
            <div className="col-xl-3 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-lg bg-primary-transparent me-3">
                      <i className="ti ti-book"></i>
                    </div>
                    <div>
                      <h4>{stats.total}</h4>
                      <p className="text-muted mb-0">Total Assignments</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-lg bg-warning-transparent me-3">
                      <i className="ti ti-clock"></i>
                    </div>
                    <div>
                      <h4>{stats.pending}</h4>
                      <p className="text-muted mb-0">Pending</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-lg bg-success-transparent me-3">
                      <i className="ti ti-check"></i>
                    </div>
                    <div>
                      <h4>{stats.submitted}</h4>
                      <p className="text-muted mb-0">Submitted</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-lg bg-danger-transparent me-3">
                      <i className="ti ti-alert-triangle"></i>
                    </div>
                    <div>
                      <h4>{stats.overdue}</h4>
                      <p className="text-muted mb-0">Overdue</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Homework List */}
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">My Homework Assignments</h4>
                </div>

                <div className="card-body border-bottom">
                  <div className="row g-3">
                    <div className="col-md-4">
                      <label className="form-label">Filter by Status</label>
                      <select
                        className="form-select"
                        value={filterStatus}
                        onChange={(e) => setFilterStatus(e.target.value)}
                      >
                        <option value="all">All Status</option>
                        <option value="Pending">Pending</option>
                        <option value="Submitted">Submitted</option>
                        <option value="Overdue">Overdue</option>
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Filter by Subject</label>
                      <select className="form-select">
                        <option>All Subjects</option>
                        <option>Mathematics</option>
                        <option>Physics</option>
                        <option>English</option>
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">&nbsp;</label>
                      <button className="btn btn-outline-secondary w-100">
                        <i className="ti ti-filter me-1"></i>Reset
                      </button>
                    </div>
                  </div>
                </div>

                <div className="card-body border-bottom">
                  <div className="alert alert-info">
                    <h6>
                      <i className="ti ti-info-circle me-2"></i>TODO: Connect to
                      homework API
                    </h6>
                    <ul className="mb-0">
                      <li>Fetch assigned homework from database</li>
                      <li>Submit homework files/responses</li>
                      <li>Track submission status</li>
                    </ul>
                  </div>
                </div>

                <div className="card-body">
                  <div className="homework-list">
                    {filteredHomework.map((homework) => (
                      <div
                        key={homework.id}
                        className="homework-item border rounded p-3 mb-3"
                      >
                        <div className="row align-items-center">
                          <div className="col-md-8">
                            <div className="homework-info">
                              <h6 className="mb-1">{homework.title}</h6>
                              <p className="text-muted mb-2">
                                {homework.description}
                              </p>
                              <div className="homework-meta">
                                <span className="badge bg-light text-dark me-2">
                                  {homework.subject}
                                </span>
                                <span className="text-muted">
                                  by {homework.teacher} • Assigned:{" "}
                                  {homework.assignedDate}
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="text-center">
                              <p className="mb-1">
                                <strong>Due Date</strong>
                              </p>
                              <p className="text-muted">{homework.dueDate}</p>
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="text-center">
                              <span
                                className={`badge ${getStatusColor(
                                  homework.status
                                )} mb-2`}
                              >
                                {homework.status}
                              </span>
                              <div className="d-flex gap-1 justify-content-center">
                                {homework.status === "Pending" ? (
                                  <button
                                    className="btn btn-primary btn-sm"
                                    data-bs-toggle="modal"
                                    data-bs-target="#homeworkDetailModal"
                                    onClick={() => handleViewHomework(homework)}
                                  >
                                    <i className="ti ti-upload"></i> Submit
                                  </button>
                                ) : homework.status === "Submitted" ? (
                                  <button
                                    className="btn btn-outline-primary btn-sm"
                                    data-bs-toggle="modal"
                                    data-bs-target="#homeworkDetailModal"
                                    onClick={() => handleViewHomework(homework)}
                                  >
                                    <i className="ti ti-eye"></i> View
                                  </button>
                                ) : (
                                  <button
                                    className="btn btn-warning btn-sm"
                                    data-bs-toggle="modal"
                                    data-bs-target="#homeworkDetailModal"
                                    onClick={() => handleViewHomework(homework)}
                                  >
                                    <i className="ti ti-upload"></i> Submit
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal */}
      <HomeworkDetailModal homework={selectedHomework} />
    </>
  );
};

export default HomeworkList;
